import { render, staticRenderFns } from "./AmbienceType.vue?vue&type=template&id=00cfbc82"
import script from "./AmbienceType.vue?vue&type=script&lang=js"
export * from "./AmbienceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00cfbc82')) {
      api.createRecord('00cfbc82', component.options)
    } else {
      api.reload('00cfbc82', component.options)
    }
    module.hot.accept("./AmbienceType.vue?vue&type=template&id=00cfbc82", function () {
      api.rerender('00cfbc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/AmbienceType.vue"
export default component.exports